import React from 'react';

const FEATURES = [
  {
    icon: '🔒',
    title: 'Análise SSL/TLS',
    desc: 'Verificação completa de certificados digitais, validade, emissor e cadeia de confiança.',
  },
  {
    icon: '🧬',
    title: 'Detecção de Phishing',
    desc: 'Algoritmos heurísticos para identificar padrões de phishing, typosquatting e URLs enganosas.',
  },
  {
    icon: '🌐',
    title: 'Reputação de Domínio',
    desc: 'Consulta em múltiplas blacklists e bases de dados de ameaças conhecidas.',
  },
  {
    icon: '📊',
    title: 'Análise Probabilística',
    desc: 'Classificação inteligente com probabilidades de fraude, falso positivo e segurança.',
  },
  {
    icon: '🔍',
    title: 'Inspeção de URL',
    desc: 'Análise detalhada da estrutura da URL, parâmetros suspeitos e redirecionamentos.',
  },
  {
    icon: '⚡',
    title: 'Scan em Tempo Real',
    desc: 'Análises executadas instantaneamente com verificação de múltiplas camadas de segurança.',
  },
];

export default function FeaturesGrid() {
  return (
    <div className="features-grid">
      {FEATURES.map((feature, i) => (
        <div key={i} className="feature-card">
          <div className="feature-icon">{feature.icon}</div>
          <div className="feature-title">{feature.title}</div>
          <div className="feature-desc">{feature.desc}</div>
        </div>
      ))}
    </div>
  );
}
